/**
 * cart-urgency.js
 * Mensaje de urgencia din\u00e1mico en el cart drawer — Lalena's Food
 *
 * Reglas de negocio:
 *   Despachos est\u00e1ndar: lunes y jueves
 *   Corte de orden: 11pm del d\u00eda anterior al despacho
 *     - Para lunes   \u2192 corte domingo  23:00
 *     - Para jueves  \u2192 corte mi\u00e9rcoles 23:00
 */
(function () {
  'use strict';

  function getDeliveryInfo() {
    var now  = new Date();
    var day  = now.getDay();          // 0=Dom 1=Lun 2=Mar 3=Mie 4=Jue 5=Vie 6=Sab
    var past = now.getHours() >= 23;  // pasado el corte de las 11pm

    // Retorna: { deliveryKey, cutoffKey, isToday }
    // deliveryKey / cutoffKey: nombre del atributo data- ('monday','thursday','wednesday','sunday')

    if (day === 0 && !past) {
      // Domingo antes de 11pm \u2192 entrega lunes, ordena HOY
      return { deliveryKey: 'monday',   cutoffKey: null,        isToday: true  };
    }
    if ((day === 1 || day === 2) || (day === 0 && past)) {
      // Lun, Mar, o Domingo noche \u2192 entrega jueves
      return { deliveryKey: 'thursday', cutoffKey: 'wednesday', isToday: false };
    }
    if (day === 3 && !past) {
      // Mi\u00e9rcoles antes de 11pm \u2192 entrega jueves, ordena HOY
      return { deliveryKey: 'thursday', cutoffKey: null,        isToday: true  };
    }
    // Mi\u00e9rcoles noche, Jue, Vie, S\u00e1b \u2192 entrega lunes
    return { deliveryKey: 'monday', cutoffKey: 'sunday', isToday: false };
  }

  function updateBanners() {
    var banners = document.querySelectorAll('[data-cart-urgency]');
    console.log('[Lalenas] cart-urgency: banners encontrados =', banners.length);
    if (!banners.length) return;

    var info = getDeliveryInfo();
    console.log('[Lalenas] cart-urgency: delivery info =', JSON.stringify(info));

    banners.forEach(function (banner) {
      var msgEl      = banner.querySelector('[data-urgency-text]');
      if (!msgEl) { console.warn('[Lalenas] cart-urgency: no se encontró [data-urgency-text] dentro del banner'); return; }

      var deliveryDay = banner.getAttribute('data-' + info.deliveryKey);
      var msg;

      if (info.isToday) {
        msg = banner.getAttribute('data-msg-today').replace('__DAY__', deliveryDay);
      } else {
        var cutoffDay = banner.getAttribute('data-' + info.cutoffKey);
        msg = banner.getAttribute('data-msg-before')
          .replace('__CUTOFF__', cutoffDay)
          .replace('__DAY__', deliveryDay);
      }

      console.log('[Lalenas] cart-urgency: mensaje =', msg);
      msgEl.textContent = msg;
      banner.style.display = 'flex';
    });
  }

  console.log('[Lalenas] cart-urgency.js cargado — readyState:', document.readyState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBanners);
  } else {
    updateBanners();
  }

  // Re-evaluar si el cart drawer se actualiza vía Ajax
  document.addEventListener('cart:updated', function () { console.log('[Lalenas] cart-urgency: evento cart:updated'); updateBanners(); });
  document.addEventListener('cart-drawer:open', function () { console.log('[Lalenas] cart-urgency: evento cart-drawer:open'); updateBanners(); });
})();
